import { lazy } from 'react';
import { Separator } from '@/shared/components/Separator';
import { Footer } from '@/widgets/Footer';
import GreetSection from '@/widgets/GreetSection';
import ProjectsSection from '@/widgets/ProjectsSection';

const Header = lazy(() => import('@/widgets/Header'));
const StackSection = lazy(() => import('@/widgets/StackSection'));

export default function MainPage() {
  return (
    <>
      <Header />
      <Separator />
      <GreetSection />
      <Separator />
      <main role="main">
        <StackSection />
        <Separator />
        <ProjectsSection />
      </main>
      <Separator />
      <Footer />
    </>
  );
}
